import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCamera_shaker } from '../voyageCamera_shaker-sidecar'
import { voyageParticles } from '../voyageParticles-sidecar'
import { voyageSounds } from '../voyageSounds-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import type { IMessageWriter } from '../../../engine/messageWriter'

import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageEffectCommand {
  command: EEffectCommand
  x?: number
  y?: number
  num?: number
}

export enum EEffectCommand {
  HitFire = 1,
  HitBreach = 2,
  Shake = 3,
  HitExplosion = 4,
  HitParticles = 5,
}

export const voyageMessageId = EVoyageMessage.EffectCommand

export function write(m: IMessageWriter, d: IMessageEffectCommand) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.command)
  messageWriter.writeFloat(m, d.x || 0)
  messageWriter.writeFloat(m, d.y || 0)
  messageWriter.write8(m, d.num || 0)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)

  let d: IMessageEffectCommand = {
    command: messageWriter.read8(m),
    x: messageWriter.readFloat(m),
    y: messageWriter.readFloat(m),
    num: messageWriter.read8(m),
  }
  return d
}

export function test() {
  let ex: IMessageEffectCommand = {
    command: EEffectCommand.HitBreach,
    x: 32,
    y: 123,
    num: 10,
  }
  messageWriter.test('effect-command', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (msg.command === EEffectCommand.HitBreach) {
    voyageSounds.playExplosionMetalDebris()
  }
  if (msg.command === EEffectCommand.HitFire) {
    voyageSounds.playExplosionFire()
  }
  if (msg.command === EEffectCommand.HitExplosion) {
    voyageSounds.playExplosion()
  }

  if (msg.command === EEffectCommand.Shake) {
    voyageCamera_shaker.shake()
  }

  if (msg.command === EEffectCommand.HitParticles) {
    voyageParticles.createMultiple(
      'weapon-hit',
      msg.x || 0,
      msg.y || 0,
      msg.num || 1,
    ) // 5 * size)
  }
  // if (msg.command === EHostCommand.Reset) {
  //   voyageGameMode_game.reset()
  // }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageEffectCommand) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
